import axios from 'axios';

// Model
export interface ConsentTextData {
    heading: string;
    headingBasic: string;
    textBasic: string;
    headingUseful: string;
    textUseful: string;
    headingAnalytics: string;
    textAnalytics: string;
    headingMarketing: string;
    textMarketing: string;
    textYes: string;
    textNo: string;
    generalButtonAccept: string;
    generalButtonChange: string;
    detailButtonSave: string;
    detailButtonBack: string;
    marketingHeading: string;
    marketingButtonText: string;
    generalMainInto: string;
    marketingMainInto: string;
}

// Fetch data
export const getConsentTexts = async (): Promise<ConsentTextData> => {
    let url = `/api/ConsentData/GetConsentTexts`;
    // If the skagenWebUrl is set, add it to the url. This means that the js is running in a different domain
    if (window.skagenWebUrl) {
        url = `${window.skagenWebUrl}${url}`;
    }
    const response = await axios.get<ConsentTextData>(url);
    return response.data;
};
